import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './SavedBooks.css';

const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

const SavedBooks = () => {
  const [books, setBooks] = useState([]);
  const [filteredBooks, setFilteredBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchSavedBooks();
  }, []);

  const fetchSavedBooks = async () => {
    try {
      const response = await axios.get(`${API_URL}/books/saved/all`);
      setBooks(response.data.books);
      setFilteredBooks(response.data.books);
    } catch (err) {
      console.error('Failed to fetch saved books:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredBooks(books);
      return;
    }

    const query = searchQuery.toLowerCase().trim();
    const filtered = books.filter(book => 
      book.title?.toLowerCase().includes(query) ||
      book.authors?.some(author => author.toLowerCase().includes(query)) ||
      book.description?.toLowerCase().includes(query)
    );

    setFilteredBooks(filtered);
  }, [searchQuery, books]);

  const handleBookClick = (googleBooksId) => {
    navigate(`/book/${googleBooksId}`);
  };

  if (loading) {
    return <div className="loading">Loading saved books...</div>;
  }

  return (
    <div className="container">
      <div className="page-header">
        <h1>My Saved Books</h1>
        <p>Your collection of saved books</p>
      </div>

      {books.length > 0 && (
        <div className="search-container">
          <input
            type="text"
            placeholder="Search by title, author, or description..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>
      )}

      {books.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">📚</div>
          <h2>No saved books yet</h2>
          <p>Start searching for books and save them to your collection!</p>
        </div>
      ) : (
        <div className="grid">
          {filteredBooks.length === 0 ? (
            <div className="no-results">
              <p>No books found matching your search.</p>
            </div>
          ) : (
            filteredBooks.map((book) => (
            <div
              key={book.id}
              className="book-card"
              onClick={() => handleBookClick(book.google_books_id)}
            >
              {book.image_url && (
                <img src={book.image_url} alt={book.title} />
              )}
              <div className="book-card-content">
                <h3>{book.title}</h3>
                <p className="book-authors">
                  {book.authors?.join(', ') || 'Unknown Author'}
                </p>
                {book.description && (
                  <div className="book-description">
                    {book.description
                      .replace(/<br\s*\/?>/gi, '\n') // Convert <br> tags to newlines first
                      .replace(/<\/p>/gi, '\n') // Convert </p> to newlines
                      .replace(/<p[^>]*>/gi, '') // Remove <p> tags
                      .replace(/<[^>]*>/g, '') // Remove remaining HTML tags
                      .replace(/&nbsp;/g, ' ') // Replace &nbsp; with spaces
                      .replace(/&amp;/g, '&') // Replace &amp; with &
                      .replace(/&lt;/g, '<') // Replace &lt; with <
                      .replace(/&gt;/g, '>') // Replace &gt; with >
                      .replace(/&quot;/g, '"') // Replace &quot; with "
                      .replace(/&#39;/g, "'") // Replace &#39; with '
                      .replace(/&apos;/g, "'") // Replace &apos; with '
                      .replace(/&#8217;/g, "'") // Replace &#8217; with '
                      .replace(/&#8220;/g, '"') // Replace &#8220; with "
                      .replace(/&#8221;/g, '"') // Replace &#8221; with "
                      .trim()
                      .substring(0, 120)}...
                  </div>
                )}
              </div>
            </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default SavedBooks;
